<template>
  <div class="picture-thumbnail" :style="`padding-top: ${ratio * 100}%`">
    <img v-lazy="{ src: src }" />
  </div>
</template>

<script>
export default {
  props: {
    picture: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    baseUrl: "",
  }),
  mounted() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL;
  },
  computed: {
    ratio() {
      return this.picture.field_media_video_file
        ? 1.34 / 1
        : (this.picture.field_height / this.picture.field_width).toFixed(2);
    },
    src() {
      return !this.picture.field_media_video_file
        ? this.baseUrl + this.picture.field_media_image_1
        : this.baseUrl + this.picture.thumbnail__target_id;
    },
  },
};
</script>

<style lang="scss">
.picture-thumbnail {
  position: relative;
  margin-bottom: 30px;
  background: linear-gradient(
    90deg,
    rgba(#6d00cf, 1) 0%,
    rgba(#6d00cf, 0.6) 50%,
    rgba(#6d00cf, 1) 100%
  );
  background-size: 200% 100%;
  // animation: moveBackground 2s infinite linear;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}

@keyframes moveBackground {
  0% {
    background-position: 200% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
